var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialogCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5762 8.60737C20.9583 3.85365 13.3611 3.74355 8.60738 8.36144C3.85367 12.9793 3.74356 20.5765 8.36146 25.3303C12.9794 30.084 20.5766 30.1941 25.3303 25.5762C30.084 20.9583 30.1941 13.3611 25.5762 8.60737Z",
    className: "bg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6075 8.36142C13.3416 3.76262 20.9775 3.87329 25.5763 8.60735C28.2415 11.3509 29.3559 14.9737 28.8809 18.4674C28.6535 15.8652 27.5237 13.3029 25.5379 11.2587C20.9391 6.52466 13.3032 6.41399 8.56911 11.0128C6.52488 12.9986 5.32138 15.527 5.0186 18.1215C4.64501 14.6156 5.86388 11.0266 8.6075 8.36142Z",
    className: "bg"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5226 11.5738C22.966 12.0302 22.9552 12.7802 22.4987 13.2236L18.6187 16.9928L22.3878 20.8728C22.8313 21.3292 22.8204 22.0792 22.3639 22.5226C21.9075 22.966 21.1575 22.9552 20.7141 22.4987L16.9449 18.6187L13.0649 22.3878C12.6085 22.8313 11.8585 22.8204 11.4151 22.3639C10.9717 21.9075 10.9826 21.1575 11.439 20.7141L15.319 16.9449L11.5499 13.0649C11.1065 12.6085 11.1173 11.8585 11.5738 11.4151C12.0302 10.9717 12.7802 10.9826 13.2236 11.439L16.9928 15.319L20.8728 11.5499C21.3292 11.1065 22.0791 11.1173 22.5226 11.5738Z",
    className: "icon"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogCloseIcon);
export default __webpack_public_path__ + "static/media/dialog-close-icon.d72d5b12.svg";
export { ForwardRef as ReactComponent };